/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Maxfeature41Inputs */

const zh_plan_maxfeature41 = /** @type {(inputs: Plan_Maxfeature41Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自定义集成`)
};

const en_plan_maxfeature41 = /** @type {(inputs: Plan_Maxfeature41Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Custom integrations`)
};

const es_plan_maxfeature41 = /** @type {(inputs: Plan_Maxfeature41Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Integraciones personalizadas`)
};

/**
* | output |
* | --- |
* | "Custom integrations" |
*
* @param {Plan_Maxfeature41Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const plan_maxfeature41 = /** @type {((inputs?: Plan_Maxfeature41Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Maxfeature41Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_plan_maxfeature41(inputs)
	if (locale === "en") return en_plan_maxfeature41(inputs)
	return es_plan_maxfeature41(inputs)
});
export { plan_maxfeature41 as "plan_maxFeature4" }